import { API } from 'aws-amplify';

// Get LoggedIn customer data
export const getCustomer = async (accessToken, customerID) => {
    const apiName = 'Customer';
    const path = '/customers/' + customerID;
    const myInit = {
        headers: {
            "Authorization": 'Bearer ' + accessToken,
        }
    };

    const customerInfo = await API.get(apiName, path, myInit)
        .then(response => {
            return response;
        });

    return customerInfo;
}

// Get LoggedIn customer data
export const getAlarmAccounts = async (accessToken, customerID) => {
    const apiName = 'Customer';
    const path = '/customers/' + customerID + '/alarm-accounts';
    const myInit = {
        headers: {
            "Authorization": 'Bearer ' + accessToken,
        }
    };

    const accountInfo = await API.get(apiName, path, myInit)
        .then(response => {
            return response;
        });

    return accountInfo;
}

// Get Orders of LoggedIn customer
export const getSales = async (accessToken, customerID) => {

    const apiName = 'Customer';
    const path = '/customers/' + customerID + '/sales';
    const myInit = {
        headers: {
            "Authorization": 'Bearer ' + accessToken,
        }
    };

    const customerInfo = await API.get(apiName, path, myInit)
        .then(response => {
            return response;
        });

    return customerInfo;
}

// Update card of LoggedIn customer
export const detachPaymentMethod = async (
    paymentMethodId,
    accessToken,
    customerID,
    stripeBillingCompany,
) => {

    const apiName = 'Customer';
    const path = '/customers/' + customerID + '/payment-methods/detach';
    const myInit = {
        headers: {
            "Authorization": 'Bearer ' + accessToken,
        },
        body: {
            "paymentMethodId": paymentMethodId,
            "stripeBillingCompany": stripeBillingCompany
        }
    };

    const paymentMethodResponse = await API.put(apiName, path, myInit)
        .then(response => {
            return response;
        });

    return paymentMethodResponse;
}

// Add Payment Method
export const addStripePaymentMethod = async (
    accessToken,
    customerID,
    stripeBillingCompany,
    stripeCustomerId,
    setupIntentId,
    confirmationToken
) => {
    console.log(setupIntentId)
    const apiName = 'Customer';
    const path = '/customers/' + customerID + '/payment-methods/add';
    const myInit = {
        headers: {
            "Authorization": 'Bearer ' + accessToken,
        },
        queryStringParameters: {
            "stripeBillingCompany": stripeBillingCompany,
            "stripeCustomerId": stripeCustomerId,
            "setupIntentId": setupIntentId,
            "confirmationToken": confirmationToken
        }
    };

    const customerPaymentMethod = await API.post(apiName, path, myInit)
        .then(response => {
            return response;
        });

    return customerPaymentMethod;
}

// Get Stripe Payment Methods
export const getStripePaymentMethods = async (
    accessToken,
    customerID,
    stripeBillingCompany,
    stripeCustomerId
) => {
    const apiName = 'Customer';
    const path = '/customers/' + customerID + '/payment-methods';
    const myInit = {
        headers: {
            "Authorization": 'Bearer ' + accessToken,
        },
        queryStringParameters: {
            "stripeBillingCompany": stripeBillingCompany,
            "stripeCustomerId": stripeCustomerId
        }
    };

    const customerPaymentMethods = await API.get(apiName, path, myInit)
        .then(response => {
            return response;
        });

    return customerPaymentMethods;
}

// Create stripe customer portal session
export const createCustomerPortalSession = async (
    accessToken,
    customerID,
    stripeBillingCompany,
    stripeCustomerId,
    returnURL,
) => {
    const apiName = 'Customer';
    const path = '/customers/' + customerID + '/customer-portal/session/create';
    const myInit = {
        headers: {
            "Authorization": 'Bearer ' + accessToken,
        },
        queryStringParameters: {
            "stripeBillingCompany": stripeBillingCompany,
            "stripeCustomerId": stripeCustomerId,
            "returnURL": returnURL 
        }
    };

    const customerPortalSession = await API.get(apiName, path, myInit)
        .then(response => {
            return response;
        });

    return customerPortalSession;
}

export default {
    getCustomer,
    getAlarmAccounts,
    getSales,
    detachPaymentMethod,
    getStripePaymentMethods,
    createCustomerPortalSession
}